module.exports = __webpack_public_path__ + "img/NHBLI.b4ce7520.png";